/**
 * Border radius constants for login components.
 * These create an organic, warped aesthetic that matches the liquid glass login card.
 */

/**
 * Border radius for buttons and text field inputs
 * Values: top-right, bottom-right, bottom-left, top-left
 * Equivalent to: 24px 20px 22px 26px
 */
export const BUTTON_BORDER_RADIUS = '1.5rem 1.25rem 1.375rem 1.625rem';

/**
 * Border radius for text field inputs (same as buttons for consistency)
 */
export const TEXTFIELD_BORDER_RADIUS = BUTTON_BORDER_RADIUS;

/**
 * Border radius for smaller UI elements (info boxes, chips, etc.)
 * Equivalent to: 12px 10px 11px 13px
 */
export const SMALL_BORDER_RADIUS = '0.75rem 0.625rem 0.6875rem 0.8125rem';

/**
 * Border radius for the login card
 * Equivalent to: 48px 40px 44px 52px
 */
export const CARD_BORDER_RADIUS = '6rem 5rem 5.5rem 6.5rem';
